const FINANCIALS_RELATIVE_INDEX_PATH = 'financials';

export const FINANCIALS_PREFIX = `/dashboard/${FINANCIALS_RELATIVE_INDEX_PATH}`;

interface FinancialsRoutes {
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
}

const financialsRoutes: FinancialsRoutes = {
  index: {
    getUrl: () => FINANCIALS_PREFIX,
    path: `${FINANCIALS_PREFIX}/*`,
    relativePath: `${FINANCIALS_RELATIVE_INDEX_PATH}/*`
  }
};

export default financialsRoutes;
